import storage, { EStorageKey } from '@aqx-core/common/storage';

export const getMarketingPageUrl = (): string => {
  return `${window.location.origin}${window.location.pathname}${storage.getItem(EStorageKey.MARKETING_PARAMS) || ''}`;
};
